import React, { useState } from 'react'
import { Button, Tooltip } from '@mui/material'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import { useNavigate } from 'react-router-dom'
import { useExpenses } from 'hooks/useExpenses'
import { useExpectedExpenses } from 'hooks/useExpectedExpenses'
import { findExpenseByRepairInvoicePath } from '@/core/expenses/repairShopInvoices'
import { findLatestExpectedByRepairTruckId } from '@/core/expenses/expectedExpenses'

const actionButtonSx = { textTransform: 'none' as const }

export function RepairInvoiceExpenseActions({
  storagePath,
  repairTruckId,
  repairShopId,
  vehicleId,
  note,
}: {
  storagePath: string
  repairTruckId: string
  repairShopId: string
  vehicleId: string | null
  note?: string
}) {
  const navigate = useNavigate()
  const { importRepairShopInvoice, isImportingRepairShopInvoice, expenses } = useExpenses()
  const {
    expectedExpenses,
    pullOverInvoice,
    isPullingInvoice,
  } = useExpectedExpenses()
  const linkedExpense = findExpenseByRepairInvoicePath(expenses, storagePath)
  const linkedExpectedExpense = findLatestExpectedByRepairTruckId(expectedExpenses, repairTruckId)
  const [isCreating, setIsCreating] = useState(false)
  const isBusy = isCreating || isImportingRepairShopInvoice || isPullingInvoice

  const openExpenseReview = (expenseId: string) => {
    navigate(`/admin/expense-management?reviewExpenseId=${expenseId}`)
  }

  const handleCreateExpense = async () => {
    setIsCreating(true)
    try {
      const expenseId = linkedExpectedExpense
        ? await pullOverInvoice(linkedExpectedExpense.id, storagePath)
        : await importRepairShopInvoice({
            storagePath,
            repairTruckId,
            vehicleId,
            repairShopId,
            note,
          })
      openExpenseReview(expenseId)
    } finally {
      setIsCreating(false)
    }
  }

  if (linkedExpense) {
    return (
      <Tooltip title="Open the expense created from this invoice">
        <Button
          size="small"
          variant="outlined"
          color="success"
          startIcon={<ReceiptLongIcon fontSize="small" />}
          onClick={() => openExpenseReview(linkedExpense.id)}
          sx={actionButtonSx}
        >
          View expense
        </Button>
      </Tooltip>
    )
  }

  return (
    <Tooltip title="Import this invoice and prefill an expense with AI">
      <span>
        <Button
          size="small"
          variant="outlined"
          startIcon={<ReceiptLongIcon fontSize="small" />}
          onClick={handleCreateExpense}
          disabled={isBusy}
          sx={actionButtonSx}
        >
          {isBusy ? 'Importing…' : linkedExpectedExpense ? 'Pull over invoice' : 'Create expense'}
        </Button>
      </span>
    </Tooltip>
  )
}
